'use strict';

require('../less/home.less');

require('./goTop');

require('./laxin');

require('./home_informationList');

require('./imStart.js');

var _util = require('./common/util.js');

var _util2 = _interopRequireDefault(_util);

var _dataservice = require('@sunl-fe/dataservice');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

//春节广告
// import './banner';
var resParams = {
    JsonDTO: {
        message: 'resultMessage',
        data: 'resultMessage',
        flag: 'rs'
    }
};
//唤起大熊

_dataservice.getJSON.initHttpDTO(resParams);

// slog初始化
function initSlog() {
    var src = '';
    // slog.base.js 记录不包括性能统计数据
    var testSrc = 'http://172.16.140.50:21001/slog/2.2.0/slog.all.js'; // 测试 slog.all.js 地址
    var prodSrc = '//assorted.sunlands.com/slog/2.2.0/slog.all.js'; // 线上 slog.all.js 地址
    if (location.host === 'www.sunlands.com') {
        src = prodSrc;
    } else {
        src = testSrc;
    }
    var slog = document.createElement('script');
    slog.src = src;
    slog.setAttribute('name', 'SLS1');
    slog.setAttribute('sid', '10125'); // 此处sid需要手动添加
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(slog, s);
}

initSlog();

$(function () {
    var swiper = new Swiper('#swiper-container-leftnews', {
        pagination: $('div[name="swiper-pagination-news"]')[0],
        slidesPerView: 1,
        paginationClickable: true,
        spaceBetween: 30,
        loop: true,
        autoplay: 5000
    });

    var swiper2 = new Swiper('#swiper-container-rightclass', {
        pagination: $('div[name="swiper-pagination-class-recommend"]')[0],
        slidesPerView: 1,
        paginationClickable: true,
        spaceBetween: 30,
        loop: true,
        autoplay: 5000
    });

    // 头部轮播图
    var swiperPersonCenter = new Swiper('#swiper-container-personCenter', {
        pagination: $('div[name="swiper-pagination-personCenter"]')[0],
        slidesPerView: 1,
        paginationClickable: true,
        spaceBetween: 30,
        loop: false,
        autoplay: 5000
    });

    $('.slider_item').click(function (e) {
        var href = $(e.target).data('href');
        // banner点击统计
        _util2["default"].slog('click_banner', { id: href });

        // 拉新banner
        if (href === 'bf-banner') {
            // 判断laxinModal是否隐藏，隐藏则显示，不隐藏则抖动提示
            var laxinModal = $('#laxinModal');
            if (laxinModal.is(':hidden')) {
                laxinModal.show();
            } else {
                _util2["default"].shake($('#laxinCnt'), 'right');
            }
            // 弹窗曝光
            _util2["default"].slog('login_popup_show', {});
        } else {
            window.open(href);
        }
    });

    // 不定时 slog.js加载不完 统计不上
    setTimeout(function () {
        // 官网home.html 统计
        _util2["default"].slog('sunlands_homepage_view', {});
    }, 2000);
});


//////////////////
// WEBPACK FOOTER
// ./src/js/home.js
// module id = 66
// module chunks = 4